import { useEffect, useState } from "react";
import { api, fileUrl, CATEGORIES } from "@/lib/api";
import { PageHero } from "@/components/site/PageHero";
import { MediaTile } from "@/components/site/MediaTile";
import { MediaLightbox } from "@/components/site/MediaLightbox";

const FILTERS = [{ value: "", label: "Todos", id: "all" }, ...CATEGORIES.map((c) => ({ ...c, id: c.value }))];

export default function Galeria() {
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState("");
  const [open, setOpen] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/media").then((r) => setItems(r.data)).finally(() => setLoading(false)); }, []);
  const shown = cat ? items.filter((m) => m.category === cat) : items;
  const cover = items.find((m) => m.category === "animales" && m.type === "image") || items.find((m) => m.type === "image");

  return (
    <div data-testid="galeria-page">
      <PageHero testid="galeria-hero" eyebrow="" title="Galería" image={fileUrl(cover?.url)} />
      <section className="container-fv py-14 sm:py-20">
        <div className="flex gap-2 overflow-x-auto pb-2" data-testid="galeria-filters">
          {FILTERS.map((f) => (
            <button key={f.id} onClick={() => setCat(f.value)} data-testid={`galeria-filter-${f.id}`}
              className={`whitespace-nowrap rounded-full px-5 py-2 text-sm font-semibold border transition-colors ${cat === f.value ? "bg-[#8B2B22] border-[#8B2B22] text-white" : "border-[#1D3324]/20 text-[#1D3324] hover:border-[#8B2B22] hover:text-[#8B2B22]"}`}>
              {f.label}
            </button>
          ))}
        </div>
        {loading ? (
          <p className="mt-12 text-[#5C635E]">Cargando…</p>
        ) : shown.length === 0 ? (
          <p className="mt-12 text-[#5C635E]" data-testid="galeria-empty">Todavía no hay contenido en esta categoría.</p>
        ) : (
          <div className="mt-10 grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3" data-testid="galeria-grid">
            {shown.map((m, i) => (
              <MediaTile key={m.id} item={m} onOpen={() => setOpen(i)} className={i % 5 === 0 ? "aspect-[4/5] sm:row-span-2 sm:aspect-auto sm:h-full" : "aspect-[4/3]"} />
            ))}
          </div>
        )}
      </section>
      <MediaLightbox items={shown} index={open} onChange={setOpen} />
    </div>
  );
}
